import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const initialState = fromJS({
  tenants: [],
  users: [],
  tenantTotal: 0,
  jobStats: {},
  tenantBillingPayload: null,
});

export const actions = {
  [ActionTypes.getTenants]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        ...payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getUsers]: {
    next(state, { payload }) {
      if (payload && payload.content) {
        return state.set("users", fromJS(payload.content));
      }
      return state.set("users", fromJS(payload));
    },
  },
  [ActionTypes.setTenantBillingPayload]: {
    next(state, { payload }) {
      return state.set("tenantBillingPayload", fromJS(payload));
    },
  },
};

export const admin = handleActions(actions, initialState);
